export default "__VITE_ASSET__BrobSJB___"